import type { User } from '@/doi-tac-module/lib/definitions';

export const consultants: User[] = [
  {
    id: 'mir-mohammad-naim',
    name: 'Nguyễn Quốc Việt',
    avatarUrl: '/img/TVV009.JPG',
    dataAiHint: 'professional man portrait',
    experience: 'trên 30 năm',
    mainExpertise: 'Tổng đại lý xuất khẩu lao động tại Bangladesh',
    company: 'HelloJob.jp',
    successfulCandidates: 50000,
    strengths: ['Tầm nhìn', 'Chiến lược', 'Kết nối cấp cao', 'Định hướng sự nghiệp'],
    messengerId: 'gu.en.beto.2025',
    phone: '+88017116667999',
    whatsapp: '+88017116667999',
    location: 'Dhaka, Bangladesh',
    email: 'agency.hq@hellojob.jp',
    status: 'approved',
    role: 'master',
    // I18n fields
    mainExpertiseI18n: {
      vi: 'Tổng đại lý xuất khẩu lao động tại Bangladesh',
      bn: 'বাংলাদেশে শ্রম রপ্তানির মাস্টার অংশীদার',
    },
    experienceI18n: { vi: 'trên 30 năm', bn: '৩০ বছরেরও বেশি' },
    strengthsI18n: [
      { vi: 'Tầm nhìn', bn: 'দূরদর্শিতা' },
      { vi: 'Chiến lược', bn: 'কৌশল' },
      { vi: 'Kết nối cấp cao', bn: 'উচ্চ-স্তর নেটওয়ার্ক' },
      { vi: 'Định hướng sự nghiệp', bn: 'ক্যারিয়ার গাইডেন্স' },
    ],
    representativeTitle: 'Sales Manager',
    representativeBio: 'Hợp tác tin cậy, kết nối bền vững vì tương lai lao động Bangladesh.',
  },
  {
    id: '2604PNBD0GH87',
    name: 'Akram Hossain',
    avatarUrl: '/img/BANGLADESH/AVATAR/BLD002.png',
    dataAiHint: 'professional man portrait',
    experience: '15 năm',
    mainExpertise: 'Đối tác Tuyển dụng & Đào tạo nguồn nhân lực',
    company: 'M Nayon Overseas Limited',
    successfulCandidates: 12000,
    strengths: ['Tuyển dụng', 'Đào tạo', 'Uy tín'],
    phone: '+8801711223344',
    whatsapp: '+8801711223344',
    messengerId: 'akram.hossain.demo',
    status: 'approved',
    role: 'agency',
    // I18n fields
    mainExpertiseI18n: {
      vi: 'Đối tác Tuyển dụng & Đào tạo nguồn nhân lực',
      bn: 'নিয়োগ ও মানব সম্পদ উন্নয়ন অংশীদার',
    },
    experienceI18n: { vi: '15 năm', bn: '১৫ বছর' },
    strengthsI18n: [
      { vi: 'Tuyển dụng', bn: 'নিয়োগ' },
      { vi: 'Đào tạo', bn: 'প্রশিক্ষণ' },
      { vi: 'Uy tín', bn: 'বিশ্বাসযোগ্যতা' },
    ],
    representativeTitle: 'CEO & Founder',
    representativeBio: 'Uy tín là vàng, đào tạo là nền tảng của sự phát triển.',
  },
  {
    id: '2604PNBD0RB88',
    name: 'Faruk Ahmed',
    avatarUrl: '/img/BANGLADESH/AVATAR/BLD006.png',
    dataAiHint: 'professional man portrait',
    experience: '20 năm',
    mainExpertise: 'Đối tác Xây dựng & Kỹ thuật công trình',
    company: 'Gulam Rabbi International Ltd.',
    successfulCandidates: 18500,
    strengths: ['Kỹ thuật', 'Xây dựng', 'Đối tác lớn'],
    phone: '+8801711556677',
    whatsapp: '+8801711556677',
    messengerId: 'faruk.ahmed.demo',
    status: 'pending',
    role: 'agency',
    // I18n fields
    mainExpertiseI18n: {
      vi: 'Đối tác Xây dựng & Kỹ thuật công trình',
      bn: 'নির্মাণ ও প্রকৌশল অংশীদার',
    },
    experienceI18n: { vi: '20 năm', bn: '২০ বছর' },
    strengthsI18n: [
      { vi: 'Kỹ thuật', bn: 'প্রকৌশল' },
      { vi: 'Xây dựng', bn: 'নির্মাণ' },
      { vi: 'Đối tác lớn', bn: 'বড় অংশীদার' },
    ],
    representativeTitle: 'Technical Director',
    representativeBio: 'Chất lượng công trình và kỹ năng vượt trội là cam kết của chúng tôi.',
  },
  {
    id: '2604PNBD0FL89',
    name: 'Shohel Rana',
    avatarUrl: '/img/BANGLADESH/AVATAR/BLD012.png',
    dataAiHint: 'professional man portrait',
    experience: '12 năm',
    mainExpertise: 'Đối tác May mặc & Sản xuất công nghiệp',
    company: 'Flamenco Overseas Ltd.',
    successfulCandidates: 9200,
    strengths: ['May mặc', 'Sản xuất', 'Nhanh chóng'],
    phone: '+8801711889900',
    whatsapp: '+8801711889900',
    messengerId: 'shohel.rana.demo',
    status: 'blocked',
    role: 'agency',
    // I18n fields
    mainExpertiseI18n: {
      vi: 'Đối tác May mặc & Sản xuất công nghiệp',
      bn: 'গার্মেন্টস ও শিল্প উৎপাদন অংশীদার',
    },
    experienceI18n: { vi: '12 năm', bn: '১২ বছর' },
    strengthsI18n: [
      { vi: 'May mặc', bn: 'গার্মেন্টস' },
      { vi: 'Sản xuất', bn: 'উৎপাদন' },
      { vi: 'Nhanh chóng', bn: 'দ্রুত' },
    ],
    representativeTitle: 'Production Manager',
    representativeBio: 'Cung cấp nguồn nhân lực may mặc nhanh chóng, hiệu quả và tay nghề cao.',
  },
  {
    id: '2604PNBD0CR90',
    name: 'Masud Rana',
    avatarUrl: '/img/BANGLADESH/AVATAR/BLD018.png',
    dataAiHint: 'professional man portrait',
    experience: '10 năm',
    mainExpertise: 'Đối tác Nông nghiệp & Lao động tay nghề cao',
    company: 'M/S. Country Road International',
    successfulCandidates: 7500,
    strengths: ['Nông nghiệp', 'Lao động tay nghề', 'Tận tâm'],
    phone: '+8801711112222',
    whatsapp: '+8801711112222',
    messengerId: 'masud.rana.demo',
    status: 'pending',
    role: 'agency',
    // I18n fields
    mainExpertiseI18n: {
      vi: 'Đối tác Nông nghiệp & Lao động tay nghề cao',
      bn: 'কৃষি ও দক্ষ শ্রম অংশীদার',
    },
    experienceI18n: { vi: '10 năm', bn: '১০ বছর' },
    strengthsI18n: [
      { vi: 'Nông nghiệp', bn: 'কৃষি' },
      { vi: 'Lao động tay nghề', bn: 'দক্ষ শ্রম' },
      { vi: 'Tận tâm', bn: 'নিষ্ঠাবান' },
    ],
  },
];


